export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10416.cc3c6e1c.jpg";